export default __webpack_public_path__ + "static/media/subtract.68707f30.png";